import { ArrowLeft, CaretRight, Tag } from "@phosphor-icons/react"

import { IconButton } from "~/components/design-system/components"
import { Separator } from "~/components/reusable/Separator"
import { type FilterFieldType } from "~/utils/filter"

/** Fields shown together behind one row of the filter editor, like the quick filters. */
export type FilterFieldGroup = { label: string; icon: React.ReactNode; fields: FilterFieldType[] }

const ROW_CLASS =
  "px-2 py-1.5 hover:bg-base-hover cursor-pointer label-base rounded-[6px] transition-colors flex flex-row items-center justify-between gap-2"

/** A group's row, or its fields once opened; picking one starts a filter on it. */
export function FilterFieldGroupList({
  group,
  open,
  onOpenChange,
  onFieldClick,
}: {
  group: FilterFieldGroup
  open: boolean
  onOpenChange: (open: boolean) => void
  onFieldClick: (field: FilterFieldType) => void
}) {
  if (!open) {
    return (
      <div className="p-1">
        <div onClick={() => onOpenChange(true)} className={ROW_CLASS}>
          <div className="flex flex-row items-center gap-2">
            {group.icon}
            {group.label}
          </div>
          <CaretRight />
        </div>
      </div>
    )
  }
  return (
    <div className="flex flex-col p-0 w-full min-w-[280px]">
      <div className="flex flex-row items-center gap-2 label-base text-fg-subtle px-2 py-1.5">
        <IconButton size="sm" onClick={() => onOpenChange(false)} variant="transparent">
          <ArrowLeft size={16} />
        </IconButton>
        {group.label}
      </div>
      <Separator orientation="horizontal" />
      <div className="flex flex-col gap-1 p-1">
        {group.fields.map((field) => (
          <div key={field.value} onClick={() => onFieldClick(field)} className={ROW_CLASS}>
            <div className="flex flex-row items-center gap-2">
              {field.icon ?? <Tag />}
              {field.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
